// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"1f6d2a94","726":"1bde0dc4","785":"c57f1ae7"}[chunkId] + ".chunk.js";
};